<template>
  <div id="content" class="content" style="margin-left:0px;">
    <h1 class="page-header" style="text-align:left">
      订单管理
      <small>/&nbsp;订单列表</small>
    </h1>

    <div
      id="page-container"
      class="in page-sidebar-fixed page-header-fixed"
      style="padding-top:0px;"
    >
      <!-- begin #content -->
      <div
        id="content"
        class="content"
        style="margin-left:0px;padding-top: 0px;padding-left:0px;padding-right:0px;"
      >
        <!-- begin breadcrumb -->

        <div class="row">
          <!-- begin col-10 -->
          <div class="col-lg-12">
            <!-- begin panel -->
            <div class="panel panel-inverse">
              <!-- begin panel-heading -->
              <div class="panel-heading">
                <div class="panel-heading-btn">
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-default"
                    data-click="panel-expand"
                  >
                    <i class="fa fa-expand"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-success"
                    data-click="panel-reload"
                  >
                    <i class="fa fa-redo"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-warning"
                    data-click="panel-collapse"
                  >
                    <i class="fa fa-minus"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-danger"
                    data-click="panel-remove"
                  >
                    <i class="fa fa-times"></i>
                  </a>
                </div>
                <h4 class="panel-title panelTitle">订单列表</h4>
              </div>
              <!-- end panel-heading -->
              <!-- begin panel-body -->
              <div class="panel-body">
                <form style="margin-top:16px;padding-left:15px;">
                  <fieldset>
                    <div class="form-group row m-b-15">
                      <label class="col-md-1 col-form-label">订单编号</label>
                      <div class="col-md-2">
                        <input
                          type="text"
                          class="form-control"
                          placeholder="订单编号"
                          v-model="orderNo"
                        />
                      </div>
                      <label class="col-md-1 col-form-label">相关渠道</label>
                      <div class="col-md-2">
                        <input
                          type="text"
                          class="form-control"
                          placeholder="渠道号/渠道名称"
                          v-model="fuzzyRecom"
                        />
                      </div>


                      <!-- <div class="col-md-2"></div> -->
                      <!-- 订单状态 -->
                      <label class="col-md-1 col-form-label">订单状态</label>
                      <div class="col-md-2">
                        <el-select
                          v-model="orderStatus"
                          clearable
                          placeholder="请选择"
                          style="width:100%;font-size:12px;"
                        >
                          <el-option
                            v-for="item in orderStatusList "
                            :key="item.code "
                            :label="item.name"
                            :value="item.code"
                          ></el-option>
                        </el-select>
                      </div>
                      <label class="col-md-1 col-form-label">企业名称</label>
                      <div class="col-md-2">
                        <el-select
                          v-model="companyId"
                          clearable
                          placeholder="请选择"
                          style="width:100%;font-size:12px;"
                        >
                          <el-option
                            v-for="item in companyList "
                            :key="item.id "
                            :label="item.commerceName"
                            :value="item.id"
                          ></el-option>
                        </el-select>
                      </div>
                      <label class="col-md-1 col-form-label LineSpacing">租户</label>
                      <div class="col-md-2 LineSpacing">
                        <el-select
                          v-model="form.lesseeId"
                          style="width:100%"
                          clearable
                          filterable
                          placeholder="请选择"
                          @change="(val) => {
                              $set(form, 'deptId', undefined)
                            $set(form, 'firstAreaId', undefined)
                            $set(form, 'secondAreaId', undefined)
                            $set(form, 'thirdAreaId', undefined)
                              departmentList = []
                              regionalList = []
                               partitionList = []
                               districtList = []
                              if (val) {
                                getDeptList()
                                getAreaPageList()
                              }
                            }"
                        >
                          <el-option
                            v-for="item in lesseeList"
                            :key="item.id"
                            :label="item.lesseeName"
                            :value="item.id"
                          ></el-option>
                        </el-select>
                      </div>
                      <label class="col-md-1 col-form-label LineSpacing">部门</label>
                      <div class="col-md-2 LineSpacing">
                        <el-select
                          v-model="form.deptId"
                          style="width:100%"
                          clearable
                          filterable
                          placeholder="请选择"
                          @change="(val) => {
                            $set(form, 'firstAreaId', undefined)
                            $set(form, 'secondAreaId', undefined)
                            $set(form, 'thirdAreaId', undefined)
                              regionalList = []
                               partitionList = []
                               districtList = []
                              getAreaPageList()
                            }"
                        >
                          <el-option
                            v-for="item in departmentList"
                            :key="item.id"
                            :label="item.deptName"
                            :value="item.id"
                          ></el-option>
                        </el-select>
                      </div>
                      <label class="col-md-1 col-form-label LineSpacing">大区</label>
                      <div class="col-md-2 LineSpacing">
                        <el-select
                          v-model="form.firstAreaId"
                          style="width:100%"
                          clearable
                          filterable
                          placeholder="请选择"
                          @change="(val) => {
                            $set(form, 'secondAreaId', undefined)
                            $set(form, 'thirdAreaId', undefined)
                               partitionList = []
                               districtList = []
                              if (val) {
                                getAreaPageList()
                              }
                            }"
                        >
                          <el-option
                            v-for="item in regionalList"
                            :key="item.id"
                            :label="item.areaName"
                            :value="item.id"
                          ></el-option>
                        </el-select>
                      </div>
                      <label class="col-md-1 col-form-label LineSpacing">分区</label>
                      <div class="col-md-2 LineSpacing">
                        <el-select
                          v-model="form.secondAreaId"
                          style="width:100%"
                          clearable
                          filterable
                          placeholder="请选择"
                          @change="(val) => {
                            $set(form, 'thirdAreaId', undefined)
                               districtList = []
                              if (val) {
                                getAreaPageList()
                              }
                            }"
                        >
                          <el-option
                            v-for="item in partitionList"
                            :key="item.id"
                            :label="item.areaName"
                            :value="item.id"
                          ></el-option>
                        </el-select>
                      </div>
                      <label class="col-md-1 col-form-label LineSpacing">区域</label>
                      <div class="col-md-2 LineSpacing">
                        <el-select
                          v-model="form.thirdAreaId"
                          style="width:100%"
                          clearable
                          filterable
                          placeholder="请选择"
                        >
                          <el-option
                            v-for="item in districtList"
                            :key="item.id"
                            :label="item.areaName"
                            :value="item.id"
                          ></el-option>
                        </el-select>
                      </div>
                      <!--订单来源 -->
                      <label class="col-md-1 col-form-label LineSpacing">订单来源</label>
                      <div class="col-md-2 LineSpacing">
                        <el-select
                          v-model="orderFrom"
                          clearable
                          placeholder="请选择"
                          style="width:100%;font-size:12px;"
                          @change="selectOrder"
                        >
                          <el-option
                            v-for="item in orderFromList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          ></el-option>
                        </el-select>
                      </div>
                      <label class="col-md-1 col-form-label LineSpacing" v-if="isO2O">门店名称</label>
                      <div class="col-md-2 LineSpacing" v-if="isO2O">
                        <input
                          type="text"
                          class="form-control"
                          placeholder="门店名称"
                          v-model="shopName"
                        />
                      </div>
                      <label class="col-md-1 col-form-label LineSpacing">下单对象</label>
                      <div class="col-md-2 LineSpacing">
                        <el-select
                          v-model="genreSelect"
                          clearable
                          placeholder="请选择"
                          style="width:100%;font-size:12px;"
                          @change="selectOrder"
                        >
                          <el-option
                            v-for="item in genreSelectList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          ></el-option>
                        </el-select>
                      </div>
                      <div class="col-md-3 LineSpacing" v-if="!isO2O"></div>
                      <label class="col-md-1 col-form-label LineSpacing">订单时间</label>
                      <div class="col-md-3 LineSpacing">
                        <el-date-picker
                          style="width:100%;height:34px;"
                          v-model="TimeValue"
                          type="datetimerange"
                          range-separator="至"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期"
                          @change="ChangePicker"
                        ></el-date-picker>
                      </div>
                      <div class="col-md-1 LineSpacing">
                        <a class="btn btn-primary ButtonColor m-r-4" @click="SearchClick()">查询</a>
                      </div>
                    </div>
                    <div style="margin-bottom:15px;text-align:right;">
                      <button type="button" class="btn btn-primary ButtonColor" @click="handleBatchPayOrder" :disabled="!handleBatchPayOrder || !multipleSelection.length">批量支付申报</button>
                      <a class="btn btn-primary ButtonColor m-r-5" @click="exportList">导出</a>
                      <a
                        class="btn btn-warning ButtonColor"
                        style="margin-right:16px;"
                        @click="CancelOrder()"
                      >取消订单</a>
                    </div>
                  </fieldset>
                </form>
                <el-table
                  :data="UserManagementList"
                   border
                  @selection-change="handleSelectionChange"
                >
                  <el-table-column type="selection" width="55"></el-table-column>
                  <el-table-column prop="ordernumber" label="序号" width="60" align="center"></el-table-column>
                  <el-table-column prop="orderNo" label="订单编号" align="center" width="180" show-overflow-tooltip></el-table-column>
                  <el-table-column prop="recom" label="渠道号" align="center" width="150" show-overflow-tooltip></el-table-column>
                  <el-table-column prop="recomName" label="渠道名称" align="center" width="180" show-overflow-tooltip></el-table-column>
                  <el-table-column prop="companyName" label="企业名称" align="center" width="180" show-overflow-tooltip></el-table-column>
                  <el-table-column prop="shopName" label="门店名称" align="center" width="200" show-overflow-tooltip></el-table-column>
                  <el-table-column prop="goodsName" label="商品名称" align="center" width="300" show-overflow-tooltip></el-table-column>
                  <el-table-column prop="orderStatusName" label="订单状态" align="center" width="150" show-overflow-tooltip></el-table-column>
                  <el-table-column prop="payVoucher" label="支付流水号" align="center" width="250" show-overflow-tooltip></el-table-column>
                  <el-table-column v-if="!isDesensitization" prop="buyerName" label="订购人" align="center" width="100" show-overflow-tooltip></el-table-column>
                  <el-table-column v-else prop="buyerNameNew" label="订购人" align="center" width="100" show-overflow-tooltip></el-table-column>
                  <el-table-column v-if="!isDesensitization" prop="buyerTel" label="联系方式" align="center" width="120" show-overflow-tooltip ></el-table-column>
                  <el-table-column v-else prop="buyerTelNew" label="联系方式" align="center" width="120" show-overflow-tooltip ></el-table-column>
                  <el-table-column prop="buyertime" label="下单时间" align="center" width="180" show-overflow-tooltip ></el-table-column>
                  <el-table-column fixed="right" label="支付申报" align="center" width="100">
                    <template slot-scope="scope">
                      <button
                        class="btn btn-primary btn-sm ButtonColor"
                        @click="DeclareClick(scope.row)"
                        :disabled="scope.row.declaredisabled"
                      >支付申报</button>
                    </template>
                  </el-table-column>
                  <el-table-column fixed="right" label="操作" width="180" align="center">
                    <template slot-scope="scope">
                      <a href="javascript:void(0);" class="btn btn-primary btn-sm" @click="DetailClick(scope.row)">详情</a>
                      <!-- <a
                        class="btn btn-primary btn-sm ButtonColor"
                        data-toggle="modal"
                        @click="DetailClick(scope.row)"
                      >详情</a> -->

                      <button
                        class="btn btn-warning btn-sm ButtonColor"
                        :disabled="scope.row.canceldisabled"
                        @click="CancelClick(scope.row)"
                      >取消订单</button>
                    </template>
                  </el-table-column>
                </el-table>
                <div class="PaginationStyle">
                  <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="pageindex"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    background
                    :total="totalCount"
                  ></el-pagination>
                </div>
              </div>
              <!-- end panel-body -->
            </div>
            <!-- end panel -->
          </div>
          <!-- end col-10 -->
        </div>
        <!-- end row -->
      </div>
      <!-- end #content -->
    </div>
    <el-dialog title :visible.sync="outerVisible" width="500px">
      <div v-if="EditDialog === 2" class="ModelPadding">
        <div class="swal-icon swal-icon--info"></div>
        <div class="swal-title">确定取消吗?</div>
        <div class="swal-footer">
          <div class="swal-button-container">
            <div class="swal-button swal-button--confirm btn btn-primary" @click="MakeSure">确定</div>
          </div>
          <div class="swal-button-container">
            <div class="swal-button swal-button--cancel btn btn-default" @click="MakeCancel">取消</div>
          </div>
        </div>
      </div>
      <div v-if="EditDialog === 3" class="ModelPadding">
        <div class="swal-icon swal-icon--info"></div>
        <div class="swal-title">确定支付申报吗?</div>
        <div class="swal-footer">
          <div class="swal-button-container">
            <button
              class="swal-button swal-button--confirm btn btn-primary"
              @click="MakeSureEdit('ruleForm')"
              :disabled="disabled"
            >确定</button>
          </div>
          <div class="swal-button-container">
            <div
              class="swal-button swal-button--cancel btn btn-default"
              @click="outerVisible = false"
            >取消</div>
          </div>
        </div>
      </div>
      <div v-if="EditDialog === 4" class="ModelPadding">
        <div class="swal-icon swal-icon--info"></div>
        <div class="swal-title">确定支付申报吗?</div>
        <div class="swal-footer">
          <div class="swal-button-container">
            <button
              class="swal-button swal-button--confirm btn btn-primary"
              @click="MakeSureEdit('ruleForm')"
              :disabled="disabled"
            >确定</button>
          </div>
          <div class="swal-button-container">
            <div
              class="swal-button swal-button--cancel btn btn-default"
              @click="outerVisible = false"
            >取消</div>
          </div>
        </div>
      </div>
    </el-dialog>


 <el-dialog :visible.sync="centerDialogVisible" width="30%" center top="34vh">
      <div class="daochu">
        <div class="daochuA">
          <div class="titleDC">按商城维度导出</div>
          <div class="contentDC">订单包含多种商品时将多个商品放在一列中显示，一笔订单一条记录</div>
          <el-button type="primary" @click="ExportClick(1)" :loading="loadingA">{{buttonNameA}}</el-button>
        </div>
        <div class="daochuC"></div>
        <div class="daochuB">
          <div class="titleDC">按门店维度导出</div>
          <div class="contentDC">订单包含多种商品时，每种商品显示一条记录</div>
          <el-button type="primary" @click="ExportClick(2)" :loading="loadingB">{{buttonNameB}}</el-button>
        </div>
      </div>
    </el-dialog>

   <el-dialog
     class="text-dialog"
      title="告知书"
      :visible.sync="DialogVisible"
      width="40%"
      center>
      <div class="text-dialog-content">
        <span class="dialog-title">告知书</span>
        <p class="dialog-text-item">1、个人信息受法律保护，任何组织、个人不得侵害自然人的个人信息权益。</p>
        <p class="dialog-text-item">2、个人信息处理者（包括但不限于个人信息的收集、存储、使用、加工、传输、提供等）应当对其个人信息处理活动负责，并采取必要措施保障所处理的个人信息的安全。</p>
        <p class="dialog-text-item">3、任何组织、个人不得非法收集、使用、加工、传输他人个人信息，不得非法买卖、提供或者公开他人个人信息。</p>
        <p class="dialog-text-item">4、个人信息处理者应当根据个人信息的处理目的、处理方式、个人信息的种类以及对个人权益的影响、可能存在的安全风险等，采取必要措施确保个人信息处理活动符合法律、行政法规的规定，并防止未经授权的访问以及个人信息泄露、篡改、丢失。</p>
        <p class="dialog-text-item">5、个人信息处理者应当指定个人信息保护负责人，负责对个人信息处理活动以及采取的保护措施等进行监督。个人信息处理者应当公开个人信息保护负责人的联系方式，并将个人信息保护负责人的姓名、联系方式等报送履行个人信息保护职责的部门。</p>
        <p class="dialog-text-item">6、发生或者可能发生个人信息泄露、篡改、丢失的，个人信息处理者应当立即采取补救措施，并通知履行个人信息保护职责的部门和个人。</p>
        <p class="dialog-text-item">7、违法处理个人信息，或者处理个人信息未履行法定的个人信息保护义务，须承担由此导致的一切法律责任。</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button  @click="() => DialogVisible = false">取消</el-button>
        <el-button type="primary" @click="() => {
          DialogVisible = false
          centerDialogVisible = true
        }">已阅读并同意</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Qs from "qs";
import axios from "axios";
import http from "../../common/http";
import MethodsBus from "../../common/methodBus";
import eventBus from "../../common/eventBus";
import { error } from "util";
import {openNewTab} from '../../utils'
import {postJSON} from '../../utils/request'
export default {
  name: "OrderList",
  data() {
    return {
      orderStatus:"3",
      orderStatusList: [],
      value1: "",
      pageSize: 10,
      totalCount: 0,
      pageindex: 1,
      orderNo: "",
      genreSelect: '',
      bagNo: "",
      startTime: "",
      endTime: "",
      shopName: "",
      outerVisible: false,
      centerDialogVisible: false,
      inputdisabled: true,
      DialogTitle: "编辑",
      EditDialog: 1,
      outerWidth: "500px",
      orderFrom: "",
      CurrentSelection: [],
      options: [],
      CloseShow: false,
      CloseShows: false,
      BrandOptions: [],
      brand: "",
      ruleForm: {},
      rules: {},
      RecomList: [],
      fuzzyRecom: "",
      TimeValue: "",
      disabled: false,
      disabledBtn: false,
      UserManagementList: [],
      DeclareList: [],
      multipleSelection: [],
      cancelShow: false,
      cancelone: false,
       buttonNameA:"商城维度导出",
      buttonNameB:"门店维度导出",
      orderFromList: [
        {
          label: "全部",
          value: ''
        },
        {
          label: "PC商城",
          value: "20"
        },
        {
          label: "O2O门店",
          value: "21"
        }
      ],
      genreSelectList: [
        {
          label: "全部",
          value: ''
        },
        {
          label: "普通用户",
          value: 1
        },
        {
          label: "门店老板",
          value: 2
        }
      ],
      isO2O: false,
      companyId:'',
      companyList:[],
      director:0,

      loadingA: false,
      loadingB: false,
      DialogVisible: false,
      isDesensitization: false,
      form: {},
      lesseeList: [],
      departmentList: [],
      regionalList: [],
      partitionList: [],
      districtList: []
    };
  },
  watch: {
    pageNo: {
      handler(newName, oldName) {
        if (this.$route.params && this.$route.params.pageNo) {
          this.pageNo = 1;
        }
      },
      immediate: true
    },
    pagesize: {
      handler(newName, oldName) {
        if (this.$route.params && this.$route.params.pagesize) {
          this.pageSize = this.$route.params.pagesize;
        }
      },
      immediate: true
    }
  },
  computed: {
    pageNo: {
      set(val) {
        if (val) {
          this.pageindex = val;
        }
      },
      get() {
        //console.log('我被调用了') //msg1获取值时触发
      }
    },
    pagesize: {
      set(val) {
        if (val) {
          this.pageSize = val;
        }
      },
      get() {
        //console.log('我被调用了') //msg1获取值时触发
      }
    }
  },
  mounted: function() {
    if (this.$route.params && this.$route.params.searchContent) {
      this.orderNo = this.$route.params.searchContent.orderNo;
      this.fuzzyRecom = this.$route.params.searchContent.fuzzyRecom;

      if (
        this.$route.params.searchContent.TimeValue !== null &&
        this.$route.params.searchContent.TimeValue !== ""
      ) {
        this.startTime = this.FormatAllDate(
          this.$route.params.searchContent.TimeValue[0]
        );
        this.endTime = this.FormatAllDate(
          this.$route.params.searchContent.TimeValue[1]
        );
      } else {
        this.startTime = "";
        this.endTime = "";
      }
      this.TimeValue = this.$route.params.searchContent.TimeValue;
      this.orderStatus = this.$route.params.searchContent.orderStatus;
      this.orderFrom = this.$route.params.searchContent.orderFrom;
    }
    // if(this.$route.query.director){
    //   this.director = this.$route.query.director;
    // }
    this.initdata();
    // 企业列表
    this.getCompanyList();
    // 订单状态数据
    this.OrderStatusData();
    this.getDesensitization()
    this.getLesseeList()
  },
  methods: {
    getLesseeList () {
      let that = this
      axios.get('/distribution/lessee/getLesseeList').then(response => {
        if (response.data.code === 200) {
          that.lesseeList = response.data.data
        } else {
          http.handleEorrorCode(response, that)
        }
      })
        .catch(error => {
          http.handleHttpError(error, that)
        })
    },
    getDeptList () {
      let that = this
      axios.get('/distribution/dept/getDeptList', {
        params: {
          lesseeId: that.form.lesseeId
        }
      }).then(response => {
        if (response.data.code === 200) {
          that.departmentList = response.data.data
        } else {
          http.handleEorrorCode(response, that)
        }
      })
        .catch(error => {
          http.handleHttpError(error, that)
        })
    },
    getAreaPageList () {
      let that = this
      axios.get('/distribution/area/getAreaList', {
        params: {
          lesseeId: that.form.lesseeId,
          deptId: that.form.deptId,
          areaType: that.form.secondAreaId ? 3 : that.form.firstAreaId ? 2 : 1,
          parentId: that.form.secondAreaId ? that.form.secondAreaId : that.form.firstAreaId ? that.form.firstAreaId : 0
        }
      }).then(response => {
        if (response.data.code === 200) {
          if (that.form.secondAreaId) {
            that.districtList = response.data.data
          } else if (that.form.firstAreaId) {
            that.partitionList = response.data.data
          } else {
            that.regionalList = response.data.data
          }
        } else {
          http.handleEorrorCode(response, that)
        }
      })
        .catch(error => {
          http.handleHttpError(error, that)
        })
    },
    getDesensitization () {
      let that = this
      axios.get('distribution/B2cOrderInfoController/getDataDesensitization').then(res => {
        if (res.data.code === 200) {
          if (!res.data.data) {
            that.isDesensitization = true
          } else {
            that.isDesensitization = false
          }
        }
      }).catch(error => {
        http.handleHttpError(error, that)
      })
    },
    exportList () {
      if (!this.isDesensitization) {
        this.DialogVisible = true
      } else {
        this.centerDialogVisible = true
      }
    },
    CancelOrder() {
      if (this.multipleSelection.length === 0) {
        this.$notify({
          title: "失败",
          message: "请选择一条数据",
          type: "error"
        });
      } else {
        this.multipleSelection.forEach(element => {
          if (
            element.orderStatus !== 1 &&
            element.orderStatus !== 2 &&
            element.orderStatus !== 3 &&
            element.orderStatus !== 4
          ) {
            this.cancelShow = true;
          }
        });

        if (this.cancelShow) {
          this.$notify({
            title: "失败",
            message: "请选择正确的数据",
            type: "error"
          });
        } else {
          this.outerVisible = true;
          this.EditDialog = 2;
        }
      }
    },
    CancelClick(row) {
      this.CurrentSelection = row;

      this.outerVisible = true;
      this.cancelone = true;
      this.EditDialog = 2;
    },
    selectOrder(val) {
      if (val == 21) {
        this.isO2O = true;
      } else {
        this.isO2O = false;
        this.shopName = "";
      }
    },
    // 获取企业列表
    getCompanyList(){
      let that = this;
      const options = {
        url: "distribution/B2cOrderInfoController/parsingUser",
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        data: Qs.stringify({})
      };
      axios(options)
        .then(response => {
          if (response.data.code == 200) {
            that.companyList = response.data.data.result;
          } else {
            http.handleEorrorCode(response, this);
          }
        })
        .catch(error => {
          http.handleEorrorCode(response, this);
        });
    },
    MakeSure() {
      let that = this;
      let orderNos = [];
      if (this.cancelone) {
        orderNos.push({
          orderId: this.CurrentSelection.orderId,
          orderNo: this.CurrentSelection.orderNo,
          orderStatus: this.CurrentSelection.orderStatus
        });
      } else {
        this.multipleSelection.forEach(val => {
          orderNos.push({
            orderId: val.orderId,
            orderNo: val.orderNo,
            orderStatus: val.orderStatus
          });
        });
      }

      that.disabled = true;
      const options = {
        url: "distribution/B2cOrderInfoController/deleteOrders",
        method: "post",
        headers: { "Content-Type": "application/json" },
        data: {
          orderNos: orderNos,
          orderStatus: that.CurrentSelection.orderStatus
        }
      };
      axios(options)
        .then(function(response) {
          that.outerVisible = false;
          that.disabled = false;
          that.cancelone = false;
          that.cancelShow = false;
          if (response.data.code == 200) {
            that.initdata();
            that.$notify({
              title: "成功",
              message: response.data.message,
              type: "success"
            });
          } else {
            http.handleEorrorCode(response, that);
          }
        })
        .catch(function(error) {
          that.outerVisible = false;
          that.cancelShow = false;
          that.disabled = false;
          that.cancelone = false;
          http.handleHttpError(error, that);
        });
    },
    MakeCancel() {
      this.outerVisible = false;
      this.cancelone = false;
      this.cancelShow = false;
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },

    handleBatchPayOrder () {
      this.$confirm('确定支付申报吗?', {
        iconClass: 'swal-icon swal-icon--info',
        center: true
      }).then(async () => {
        const res = await postJSON(
          `distribution/B2cDeclareCustomsController/batchDeclareType`,
          this.multipleSelection.map(({ payType, orderNo, recom }) => ({
            payType,
            orderNo,
            recom
          }))
        ).catch(res => http.handleHttpError(error, this))

        this.outerVisible = false
        this.disabled = false

        if (res.data.code === 200) {
          this.initdata()
          this.$notify({
            message: res.data.message,
            type: 'info'
          })
        }
      })
    },
    ExportClick(id) {
      let that = this;
      this.disabledBtn = true;
      const options = {
        url: "/distribution/ExcelController/exportOrderInfo",
        method: "get",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        params: {
          exportType: id,
          orderNo: that.orderNo,
          fuzzyRecom: that.fuzzyRecom,
          orderFrom: that.orderFrom,
          genreSelect: that.genreSelect,
          orderStatus: that.orderStatus,
          cid: that.companyId,
          startTime: that.startTime,
          endTime: that.endTime,
          shopName: that.shopName,
          director:0,
          lesseeId: that.form.lesseeId,
          deptId: that.form.deptId,
          firstAreaId: that.form.firstAreaId,
          secondAreaId: that.form.secondAreaId,
          thirdAreaId: that.form.thirdAreaId
        }
      };
      axios(options)
        .then(function(response) {
          if (response.data.code !== undefined) {
            http.handleEorrorCode(response, that);
            that.disabledBtn = false;
          } else {
            that.ExportClickSecond(id);
          }
        })
        .catch(error => {
          http.handleHttpError(error, that);
          that.disabledBtn = false;
        });
    },
    ExportClickSecond(id) {
      let that = this;
      const options = {
        url: "/distribution/ExcelController/exportOrderInfo",
        method: "get",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        params: {
          exportType: id,
          orderNo: that.orderNo,
          fuzzyRecom: that.fuzzyRecom,
          orderFrom: that.orderFrom,
          genreSelect: that.genreSelect,
          orderStatus: that.orderStatus,
          cid: that.companyId,
          startTime: that.startTime,
          endTime: that.endTime,
          shopName: that.shopName,
          director:0,
          lesseeId: that.form.lesseeId,
          deptId: that.form.deptId,
          firstAreaId: that.form.firstAreaId,
          secondAreaId: that.form.secondAreaId,
          thirdAreaId: that.form.thirdAreaId
        },
        responseType: "blob"
      };
      axios(options)
        .then(function(response) {
          that.disabledBtn = false;
          var filename = "订单列表" + new Date().getTime();
          let url = window.URL.createObjectURL(response.data);
          let link = document.createElement("a");
          link.style.display = "none";
          link.href = url;
          link.setAttribute("download", filename + ".xlsx");
          document.body.appendChild(link);
          link.click();
        })
        .catch(error => {
          http.handleHttpError(error, that);
          that.disabledBtn = false;
        });
    },
    DeclareClick(item) {
      this.outerVisible = true;
      this.EditDialog = 3;
      this.CurrentSelection = item;
      this.ruleForm = {};
      if (this.$refs["ruleForm"]) {
        this.$refs["ruleForm"].resetFields();
      }
    },
    MakeSureEdit(formName) {
      let that = this;
      that.disabled = true;
      const options = {
        url: "distribution/B2cDeclareCustomsController/declareType",
        method: "post",
        headers: { "Content-Type": "application/json" },
        data: {
          payType: that.CurrentSelection.payType,
          orderNo: that.CurrentSelection.orderNo,
          recom: that.CurrentSelection.recom
        }
      };
      axios(options)
        .then(function(response) {
          that.outerVisible = false;
          that.disabled = false;
          if (response.data.code == 200) {
            that.initdata();
            that.$notify({
              title: "成功",
              message: response.data.message,
              type: "success"
            });
          } else {
            http.handleEorrorCode(response, that);
          }
        })
        .catch(function(error) {
          http.handleHttpError(error, that);
        });
    },

    DetailClick(row) {
      let searchContent = {};
      searchContent.orderNo = this.orderNo;
      searchContent.fuzzyRecom = this.fuzzyRecom;
      searchContent.TimeValue = this.TimeValue;
      searchContent.orderFrom = this.orderFrom;
      searchContent.orderStatus = this.orderStatus;
      // let href = this.$router.resolve({ path: "/orderdetail", query:{check:1}});
      //  window.open(href.href, '_blank');

      // this.$router.push({ path: "/orderdetail", query:{check:1}});
      localStorage.setItem(
        "goodlist",
        JSON.stringify({
          row: row,
          pageNo: this.pageindex,
          pageSize: this.pageSize,
          searchContent: searchContent
        })
      );

      openNewTab(`./#/orderdetail?check=1`)
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.pageindex = 1;
      this.initdata();
    },
    handleCurrentChange(val) {
      this.pageindex = val;
      this.initdata();
    },
    SearchClick() {
      this.pageindex = 1;
      this.initdata();
    },
    ChangePicker() {
      if (this.TimeValue !== null) {
        this.startTime = this.FormatAllDate(this.TimeValue[0]);
        this.endTime = this.FormatAllDate(this.TimeValue[1]);
      } else if (this.TimeValue === null) {
        this.startTime = "";
        this.endTime = "";
      }
    },
    FormatAllDate(sDate) {
      var date = new Date(sDate);
      var seperator1 = "-";
      var seperator2 = ":";
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      var hours = date.getHours();
      var minutes = date.getMinutes();
      var seconds = date.getSeconds();
      //月
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      //日
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      //时
      if (hours >= 0 && hours <= 9) {
        hours = "0" + hours;
      }
      //分
      if (minutes >= 0 && minutes <= 9) {
        minutes = "0" + minutes;
      }
      //秒
      if (seconds >= 0 && seconds <= 9) {
        seconds = "0" + seconds;
      }
      //格式化后日期为：yyyy-MM-dd HH:mm:ss
      var currentdate =
        date.getFullYear() +
        seperator1 +
        month +
        seperator1 +
        strDate +
        " " +
        hours +
        seperator2 +
        minutes +
        seperator2 +
        seconds;

      return currentdate;
    },
    FormatSpecialDate(sDate) {
      var date = new Date(sDate);
      var seperator1 = "-";
      var seperator2 = ":";
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      var hours = date.getHours();
      var minutes = date.getMinutes();
      var seconds = date.getSeconds();
      //月
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      //日
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      //时
      if (hours >= 0 && hours <= 9) {
        hours = "0" + hours;
      }
      //分
      if (minutes >= 0 && minutes <= 9) {
        minutes = "0" + minutes;
      }
      //秒
      if (seconds >= 0 && seconds <= 9) {
        seconds = "0" + seconds;
      }
      //格式化后日期为：yyyy-MM-dd HH:mm:ss
      var currentdate =
        date.getFullYear() + seperator1 + month + seperator1 + strDate;

      return currentdate;
    },
    // 订单状态数据
    OrderStatusData() {
      const options = {
        url: "distribution/b2c-distribution-status-controller/query-all",
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        data: Qs.stringify({})
      };
      axios(options)
        .then(response => {
          if (response.data.code == 200) {
            this.orderStatusList = response.data.data;
          } else {
            http.handleEorrorCode(response, this);
          }
        })
        .catch(error => {
          http.handleEorrorCode(response, this);
        });
    },
    initdata() {
      let that = this;
      const options = {
        url: "distribution/B2cOrderInfoController/queryGoodsOrders",
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        data: Qs.stringify({
          director: that.director,
          orderNo: that.orderNo,
          fuzzyRecom: that.fuzzyRecom,
          orderFrom: that.orderFrom,
          genreSelect: that.genreSelect,
          orderStatus: that.orderStatus,
          cid: that.companyId,
          startTime: that.startTime,
          endTime: that.endTime,
          shopName: that.shopName,
          size: that.pageSize,
          current: that.pageindex,
          lesseeId: that.form.lesseeId,
          deptId: that.form.deptId,
          firstAreaId: that.form.firstAreaId,
          secondAreaId: that.form.secondAreaId,
          thirdAreaId: that.form.thirdAreaId
        })
      };
      axios(options)
        .then((response)=> {
          if (response.data.code == 200) {
            that.totalCount = response.data.data.totalCount;
            that.cancelShow = false;
            for (var i in response.data.data.data) {
              if (
                response.data.data.data[i].orderStatus === 1 ||
                response.data.data.data[i].orderStatus === 2 ||
                response.data.data.data[i].orderStatus === 3 ||
                response.data.data.data[i].orderStatus === 4
              ) {
                response.data.data.data[i].canceldisabled = false;
              } else {
                response.data.data.data[i].canceldisabled = true;
              }
              response.data.data.data[i].ordernumber =
                Number((that.pageindex - 1) * that.pageSize) + Number(i) + 1;
              if (response.data.data.data[i].buyerTime !== null) {
                response.data.data.data[i].buyertime = that.FormatAllDate(
                  response.data.data.data[i].buyerTime
                );
              } else {
                response.data.data.data[i].buyertime = "";
              }

              if (
                response.data.data.data[i].orderStatus === 3 ||
                response.data.data.data[i].orderStatus === 4 ||
                response.data.data.data[i].orderStatus === 5 ||
                response.data.data.data[i].orderStatus === 6
              ) {
                response.data.data.data[i].declaredisabled = false;
              } else {
                response.data.data.data[i].declaredisabled = true;
              }
            }

            that.UserManagementList = response.data.data.data;
          } else {
            http.handleEorrorCode(response, that);
          }
        })
        .catch(function(error) {
          http.handleHttpError(error, that);
        });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.clear {
  clear: both;
}
.PaginationStyle {
  float: right;
  margin-top: 8px;
}
.panelTitle {
  padding-left: 15px;
  text-align: left;
}
.ButtonColor {
  color: #fff !important;
}
.ModelPadding {
  margin-top: -20px;
}
.LineSpacing {
  margin-top: 16px;
}
.InputWidth {
  width: 202px;
}
.daochu {
  overflow: hidden;
  margin-bottom: 30px;
}
.daochuA {
  width: 45%;
  float: left;
  text-align: center;
}
.daochuB {
  width: 45%;
  float: right;
  text-align: center;
}
.titleDC {
  font-size: 18px;
  font-weight: 600;
}
.contentDC{
  padding: 25px;
  height: 120px;
}
.daochuC {
  float: left;
	width: 5%;
	border-right: 2px dashed #AFCEE7;
	padding-bottom: 150px;  /*关键*/
	margin-bottom: -150px;  /*关键*/
}
.text-dialog >>> .el-dialog__header {
  text-align: left;
  border-bottom: 1px solid #f2f2f2;
}
.text-dialog-content {
  width: 100%;
}
.dialog-title {
  display: inline-block;
  width: 100%;
  text-align: center;
  font-size: 26px;
  font-weight: bold;
  margin-bottom: 20px;
}
.dialog-text-item {
  text-indent: 2rem;
}
.text-dialog >>> .el-dialog__footer {
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/components/OrderManage/OrderList.vue